import React from 'react';

import PropTypes from 'prop-types';

import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { LOGIN_REGISTRATION_FORM_NAME } from 'apps/auth/constants/formName';

import { SearchBarContainer, SearchBarContent, Shadow } from './styles';

export const SearchBar = (props) => {
    const setAutocomplete = () => {
        const fieldName = props.field?.name;
        let autocompleteValue = 'off';
        if (props.formName === LOGIN_REGISTRATION_FORM_NAME) {
            autocompleteValue = fieldName === 'address' ? 'street-address' : 'off';
        }
        return autocompleteValue;
    };

    return (
        <SearchBarContainer>
            <SearchBarContent>
                <DiskButton iconName="arrow-back" raised={false} type="button" onClick={props.onCloseButtonClick} />
                <input
                    type="search"
                    name="search"
                    size="100"
                    autoComplete={setAutocomplete()}
                    value={props.value}
                    placeholder={props.placeholder}
                    autoFocus={true}
                    onChange={props.onChange}
                    ref={props.searchRef}
                />
            </SearchBarContent>
            <Shadow />
        </SearchBarContainer>
    );
};

SearchBar.propTypes = {
    onCloseButtonClick: PropTypes.func,
};
